<template>
  <div>
    <CategoryConsumptionPage
      :consumption_category_id="1"
      :showFuelGasAndDieselChart="false"
      :colors="{ primary: '#A4D1DE', secondary: '#CBDADE', tertiary: '#DBE5E8' }"
      titleCompare="Electricity consumption compare to Diesel & Gas"
      :consumption_category="{ name: 'electricity', unit: { text: 'kWh' } }"
    >
    </CategoryConsumptionPage>
  </div>
</template>

<script>
import CategoryConsumptionPage from '@/components/consumption/CategoryConsumptionPage';
import ConsumptionNotificationsController from '@/controllers/Consumption/ConsumptionNotificationsController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
export default {
  name: 'ElectricityConsumptionPage',
  components: { MoonLoader, CategoryConsumptionPage },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
